import apiHandler from './apiHandler'; 

const FetchSingleProduct = async (request) => {
    try {

        const params = new URLSearchParams(request).toString();
    
        const response = await apiHandler({
          endpoint2: `/product?${params}`,
          method: 'GET',
        });
    
        if (response?.response_code === 200) {
          return response;
        } else {
          throw new Error(response.message || 'Failed to fetch products');
        }
      } catch (error) {
        console.error("Error fetching products", error);
        throw error;
      }
};

export default FetchSingleProduct;